import { api } from './api'
import type { FnaFormData, ResultsSummary } from '../types'

export interface FnaSummaryResponse {
  summary: ResultsSummary
  form_data: FnaFormData | null
  data_source: string
  user_id: number
}

export const fetchFnaSummary = async (): Promise<FnaSummaryResponse | null> => {
  try {
    const response = await api.get<FnaSummaryResponse>('/api/v1/fna/summary/')
    return response.data
  } catch (error) {
    console.warn('No FNA summary available for current user:', error)
    return null
  }
}
